document.addEventListener('DOMContentLoaded', async function () {
  // sessionStorageからフォームデータを取得
  const formDataString = sessionStorage.getItem('request-form-data');

  console.log(formDataString);
  if (formDataString) {
    try {
      const formData = JSON.parse(formDataString);
      formData.locale = Shopify.locale;

      // 取得したデータで確認ページを埋める
      const categoryContainer = document.querySelector('#target-confirm');
      const previewTargetsString = sessionStorage?.getItem('preview-targets') || '[]';
      const previewTargets = JSON.parse(previewTargetsString);
      categoryContainer.innerHTML = ''; // デフォルトのカテゴリーをクリア

      previewTargets.forEach(targetItem => {
        const span = document.createElement('span');
        span.className = 'category-path';
        span.textContent = targetItem;
        categoryContainer.appendChild(span);
      });

      // キーワードフィールドを設定 - 必要に応じて配列のアイテムを結合
      if (formData.keywords && formData.keywords.length) {
        document.querySelector('#keywords-confirm').textContent = formData.keywords.join(', ');
      }

      // minPriceとmaxPriceを使用して価格範囲を設定
      if (formData.minPrice || formData.maxPrice) {
        const priceCell = document.querySelector('#priceRange-confirm');

        if (formData.minPrice && formData.maxPrice) {
          priceCell.textContent = `¥${Number(formData.minPrice)?.toLocaleString()} ~ ¥${Number(formData.maxPrice)?.toLocaleString()}`;
        } else if (formData.minPrice) {
          priceCell.textContent = `¥${Number(formData.minPrice)?.toLocaleString()} ~`;
        } else if (formData.maxPrice) {
          priceCell.textContent = `~ ¥${Number(formData.maxPrice)?.toLocaleString()}`;
        }
      }

      // 送信ボタンの機能を追加
      document.querySelector('.submit-button').addEventListener('click', async function () {
        document.querySelector('.submit-button')?.classList?.add('loading');
        document.querySelector('.submit-button .loading__spinner')?.classList?.remove('hidden');
        // ここでフォーム送信を処理
        // 例えば、データをサーバーエンドポイントに送信
        const requestUid = (URLSearchParams && new URLSearchParams(window.location.search)?.get('requestUid')) || null;
        if (requestUid) {
          formData.requestUid = requestUid;
        }
        const previewTargetsString = sessionStorage?.getItem('preview-targets') || '[]';
        const previewTargets = JSON.parse(previewTargetsString);
        formData.previewTargets = previewTargets;
        const requestResponse = await fetch('/tools/notify-product/create-request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(res => res.json())
          .catch((error) => {
            console.error('エラー:', error);
            alert('リクエストの送信中にエラーが発生しました。');
          });
        console.log(requestResponse);
        if (requestResponse.status == "success") {
          sessionStorage.removeItem('request-form-data');
          sessionStorage.removeItem('preview-targets');
          window.location.href = Shopify.routes.root + 'account';
          alert("入荷通知リクエストの登録に成功しました");

          document.querySelector('.submit-button')?.classList?.remove('loading');
          document.querySelector('.submit-button .loading__spinner')?.classList?.add('hidden');
        }
      });
    } catch (error) {
      console.error('sessionStorageからフォームデータの解析エラー:', error);
      alert('フォームデータの解析中にエラーが発生しました。');
      document.querySelector('.submit-button')?.classList?.remove('loading');
      document.querySelector('.submit-button .loading__spinner')?.classList?.add('hidden');
    }
  } else {
    console.warn('sessionStorageにフォームデータが見つかりません');
    alert('フォームデータが見つかりませんでした。');

    document.querySelector('.submit-button')?.classList?.remove('loading');
    document.querySelector('.submit-button .loading__spinner')?.classList?.add('hidden');
  }
});


async function previewProducts() {
  try {
    const formDataString = sessionStorage.getItem('request-form-data');
    const formData = JSON.parse(formDataString);
    formData.locale = Shopify.locale;
    const productGrid = document.getElementById('product-grid');
    const loadingSpinner = document.createElement('div');
    loadingSpinner.className = 'loading-spinner';
    loadingSpinner.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
      </svg>
    `;

    productGrid.appendChild(loadingSpinner);
    const previewProducts = await fetch('/tools/notify-product/get-preview-products', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(res => res.json());
    console.log(previewProducts);
    document.querySelector('.loading-spinner').remove();
    if (previewProducts.status == "error") {
      alert(previewProducts.message);
      return;
    }
    for (const product of previewProducts) {
      const productElement = document.createElement('li');
      productElement.classList.add('grid__item', "scroll-trigger", "animate--slide-in");
      productElement.innerHTML = `
        <div class="bl_grid-product-card bl_product-card">
          <a href="${Shopify.routes.root}products/${product.handle}" class="bl_product-card__link us_link">
            <div class="bl_product-card__inner">
              <div class="bl_product-card__media">
                <img src="${product.images.nodes?.[0]?.originalSrc}" alt="${product.title}" loading="lazy" width="480" height="640">
              </div>
              <div class="bl_product-card__content">
                <div class="bl_product-card__wrapper">
                  ${product.metafields.nodes.find(node => node.key == "custom.rare") ? `<div class="bl_product-card__tag _rate">${product.metafields.nodes.find(node => node.key == "custom.rare").value}</div>` : ''}
                  ${product.metafields.nodes.find(node => node.key == "custom.price") ? `<div class="bl_product-card__tag _price">${product.metafields.nodes.find(node => node.key == "custom.price").value}</div>` : ''}
                  ${product.metafields.nodes.find(node => node.key == "custom.attribute")?.value ? `<div class="bl_product-card__tag _attribute">${JSON.parse(product.metafields.nodes.find(node => node.key == "custom.attribute").value)?.join("・")}</div>` : ''}
                  <div class="bl_product-card__title hp_line-clamp _2">${product.title}</div>
                </div>
                <div class="bl_product-card__wrapper">
                  <div class="bl_product-card__price">
                    <div class="price">
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="price-item price-item--regular">
                            ¥${Math.floor(product.priceRangeV2?.maxVariantPrice?.amount || product.priceRangeV2?.minVariantPrice?.amount).toLocaleString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table class="bl_grid-product-card__table">
                    <tbody>
                      <tr>
                        <td class="bl_grid-product-card__data">${product.metafields.nodes.find(node => node.key == "custom.category")?.value || "なし"}</td>
                      </tr>
                      <tr>
                        <td class="bl_grid-product-card__data">${product.metafields.nodes.find(node => node.key == "custom.info")?.value || "なし"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </a>
        </div>
      `;
      productGrid.appendChild(productElement);
    }
  } catch (error) {
    console.error(error);
    alert('プレビュー商品の取得に失敗しました。');
  }
}
previewProducts();